import { render, staticRenderFns } from "./CompStudentLists.vue?vue&type=template&id=6924d86f"
import script from "./CompStudentLists.vue?vue&type=script&lang=js"
export * from "./CompStudentLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports